.error-message {
    color: var(--solid-ui-color-error);
    font-size: var(--solid-ui-font-size-sm);
    font-weight: 500;
    text-align: center;
    width: 100%;
}

solid-ui-combobox {
    width: 100%;
}

solid-ui-button {
    flex: 1;
}
